import axios from 'axios'

export interface EmailConfirmationResponse {
  user: {
    id: string
    email: string
    first_name: string
    last_name: string
    confirmed: boolean
    profile_used: string
    locale?: string
    selected_school_id?: string
    username?: string
  }
  message: string
}

export interface EmailConfirmationError {
  error: string
  details?: string
}

/**
 * Confirms user email and creates authenticated session
 * @param confirmationToken - Confirmation token from email link
 * @returns Promise with user data or error
 */
export async function confirmEmail(
  confirmationToken: string
): Promise<{ success: boolean; data?: EmailConfirmationResponse; error?: EmailConfirmationError }> {
  console.log('[EmailConfirmationService] Confirming email...')
  console.log('[EmailConfirmationService] Token (first 20 chars):', confirmationToken.substring(0, 20) + '...')

  try {
    const response = await axios.post<EmailConfirmationResponse>(
      '/api/arc_mosaico/auth/confirm_email',
      { confirmation_token: confirmationToken },
      {
        headers: {
          'Content-Type': 'application/json',
        },
        withCredentials: true, // IMPORTANT: Include credentials for session cookies
      }
    )

    console.log('[EmailConfirmationService] ✅ Email confirmed! User:', response.data.user.email)
    console.log('[EmailConfirmationService] Session created, user authenticated')

    return {
      success: true,
      data: response.data,
    }
  } catch (error) {
    console.error('[EmailConfirmationService] ❌ Confirmation failed:', error)

    if (axios.isAxiosError(error) && error.response) {
      console.error('[EmailConfirmationService] Error response:', error.response.data)
      console.error('[EmailConfirmationService] Status code:', error.response.status)

      return {
        success: false,
        error: error.response.data,
      }
    }

    console.error('[EmailConfirmationService] Network error:', error)

    return {
      success: false,
      error: {
        error: 'Network error',
        details: error instanceof Error ? error.message : 'Unknown error',
      },
    }
  }
}
